// ----------------------------------------------------------------------

export default function Tooltip(theme) {
    // `background.tooltip` is grey 800 in light and steps lighter in dark,
    // where grey 800 is the paper the tooltip floats over.
    const background = theme.palette.background.tooltip;

    return {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: background,
                    color: theme.palette.common.white,
                },
                arrow: {
                    color: background,
                },
            },
        },
    };
}
